module.exports = __webpack_public_path__ + "static/media/book-alt.93cd5fe8.svg";